import React, { useState } from 'react'
import { useStore } from '../../store'
import GestureRecognition from './GestureRecogintion'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [setCameraON, cameraON] = useStore((state) => [
    state.setCameraON,
    state.cameraON,
  ])

  const handleWebcamToggle = () => {
    setCameraON()
    if (!cameraON) setIsLoading(true)
  }

  return (
    <div>
      <div
        className={`webcam-button ${!cameraON ? 'glow' : ''}`}
        onClick={handleWebcamToggle}
      >
        {isLoading && cameraON ? (
          <img
            src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif"
            alt="Loading..."
            width="40"
            height="40"
          />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="#fff"
            viewBox="0 0 16 16"
          >
            <path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H9.269c.144.162.33.324.531.475a6.785 6.785 0 0 0 .907.57l.014.006.003.002A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.224-.947l.003-.002.014-.007a4.473 4.473 0 0 0 .268-.148 6.75 6.75 0 0 0 .639-.421c.2-.15.387-.313.531-.475H2a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2Z" />
            <path d="M8 6.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
          </svg>
        )}
        <span className="tooltip">
          Unleash the magic! Turn on your webcam to control Pikachu with your
          Hand Gestures!
        </span>
      </div>

      {cameraON && (
        <>
          <GestureRecognition
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <div className="gestureInstructions">
            <p>Use the following gestures for movement:</p>
            <p>
              <span>✋</span> Move forward
            </p>
            <p>
              <span>✊</span> Move backward
            </p>
            <p>
              <span>👈</span> Move left
            </p>
            <p>
              <span>👉</span> Move right
            </p>
          </div>
        </>
      )}
    </div>
  )
}

export default App
